module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_4.ac0721d6.png";